import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import PrivacyPolicy from '../../components/Legal/PrivacyPolicy';
import TermsAndConditions from '../../components/Legal/TermsAndConditions';
import Footer from '../../components/Footer/Footer';
import HeroSection from '../../components/Hero-Section/HeroSection';
import Header from '../../components/Header/Header';

const Legal = () => {

    const { legalCat } = useParams();
  const legalCategory = legalCat === "" || legalCat === null ? "top_menu" : legalCat;

  useEffect(() => {
    if (legalCategory !== null && legalCategory !== "") {
      document.getElementById(legalCategory).scrollIntoView();
    }
  });

  const navigate = useNavigate();



  return (
    <>
    <Header selected="legal" />
    <HeroSection />
    {legalCategory === "" || legalCategory === null ? (
      navigate("/", { replace: true })
    ) : legalCategory === "privacy-policy" ? (
      <PrivacyPolicy />
    ) : legalCategory === "terms-and-conditions" ? (
      <TermsAndConditions />
    ) : (
      navigate("/", { replace: true })
    )}
    <Footer />
  </>
  )
}

export default Legal